import React, { useState } from "react";
import {
    CheckCircle2,
    Clock3,
    AlertCircle,
    TrendingUp,
    BarChart3,
    ArrowDown,
    CalendarDays,
    ChevronDown,
} from "lucide-react";
import "../PerformanceStyles.css";

/* ── Static demo data ── */
const kpiCards = [
    {
        label: "Objectifs atteints",
        value: "7/10",
        hint: "Sur vos objectifs annuels",
        icon: CheckCircle2,
        iconBg: "#e8edf7",
        iconColor: "#2f4595",
    },
    {
        label: "Objectifs en cours",
        value: "2",
        hint: "À finaliser avant l'entretien",
        icon: Clock3,
        iconBg: "#dbeafe",
        iconColor: "#2563eb",
    },
    {
        label: "Objectifs non atteints",
        value: "1/10",
        hint: "Points à améliorer",
        icon: AlertCircle,
        iconBg: "#fff1f2",
        iconColor: "#2f4595",
    },
    {
        label: "Surperformances",
        value: "3",
        hint: "Dépassements d'objectifs",
        icon: TrendingUp,
        iconBg: "#e8edf7",
        iconColor: "#2f4595",
    },
    {
        label: "Taux de réussite",
        value: "70%",
        hint: "Progression globale",
        icon: BarChart3,
        iconBg: "#fff1f2",
        iconColor: "#2f4595",
    },
    {
        label: "Points d'amélioration",
        value: "2",
        hint: "Compétences à développer",
        icon: ArrowDown,
        iconBg: "#e8edf7",
        iconColor: "#2f4595",
    },
];

const evaluations = [
    {
        date: "15/01/2024",
        performance: 85,
        surperformance: 15,
        tolerance: "0%",
        statut: "Réalisé",
        evaluation: "Évaluation Performance 2024",
    },
    {
        date: "30/06/2023",
        performance: 78,
        surperformance: 10,
        tolerance: "20%",
        statut: "Réalisé",
        evaluation: "Évaluation Mi-Année 2023",
    },
    {
        date: "15/12/2023",
        performance: 82,
        surperformance: 12,
        tolerance: "10%",
        statut: "Réalisé",
        evaluation: "Évaluation Annuelle 2023",
    },
];

export default function TDBcollab() {
    const [campagne, setCampagne] = useState("campagne de performance");
    const [dateDebut, setDateDebut] = useState("");
    const [dateFin, setDateFin] = useState("");

    return (
        <div className="tdb-collab-page">
            <style>{tdbCollabStyles}</style>

            {/* ── Filters bar ── */}
            <section className="tdb-c-filters">
                <div className="tdb-c-filter-group">
                    <label className="tdb-c-filter-label">Campagne</label>
                    <div className="tdb-c-select-wrap">
                        <select
                            className="tdb-c-select"
                            value={campagne}
                            onChange={(e) => setCampagne(e.target.value)}
                        >
                            <option>campagne de performance</option>
                        </select>
                        <ChevronDown size={16} className="tdb-c-select-icon" />
                    </div>
                </div>

                <div className="tdb-c-filter-group tdb-c-filter-date">
                    <label className="tdb-c-filter-label">Date de début</label>
                    <div className="tdb-c-date-wrap">
                        <input
                            type="date"
                            className="tdb-c-date-input"
                            value={dateDebut}
                            onChange={(e) => setDateDebut(e.target.value)}
                            placeholder="jj/mm/aaaa"
                        />
                        <CalendarDays size={16} className="tdb-c-date-icon" />
                    </div>
                </div>

                <div className="tdb-c-filter-group tdb-c-filter-date">
                    <label className="tdb-c-filter-label">Date de fin</label>
                    <div className="tdb-c-date-wrap">
                        <input
                            type="date"
                            className="tdb-c-date-input"
                            value={dateFin}
                            onChange={(e) => setDateFin(e.target.value)}
                            placeholder="jj/mm/aaaa"
                        />
                        <CalendarDays size={16} className="tdb-c-date-icon" />
                    </div>
                </div>
            </section>

            {/* ── KPI cards ── */}
            <section className="tdb-c-kpi-grid">
                {kpiCards.map((kpi) => {
                    const Icon = kpi.icon;
                    return (
                        <article className="tdb-c-kpi-card" key={kpi.label}>
                            <div className="tdb-c-kpi-top">
                                <span
                                    className="tdb-c-kpi-icon"
                                    style={{ background: kpi.iconBg, color: kpi.iconColor }}
                                >
                                    <Icon size={22} />
                                </span>
                                <div className="tdb-c-kpi-info">
                                    <span className="tdb-c-kpi-label">{kpi.label}</span>
                                </div>
                            </div>
                            <div className="tdb-c-kpi-bottom">
                                <span className="tdb-c-kpi-value">{kpi.value}</span>
                                <span className="tdb-c-kpi-hint">{kpi.hint}</span>
                            </div>
                        </article>
                    );
                })}
            </section>

            {/* ── Evaluations table ── */}
            <section className="tdb-c-evaluations">
                <h2 className="tdb-c-eval-title">Mes évaluations</h2>
                <div className="tdb-c-table-wrap">
                    <table className="tdb-c-table">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Performance</th>
                                <th>Surperformance</th>
                                <th>Tolérance</th>
                                <th>Statut</th>
                                <th>Évaluation</th>
                            </tr>
                        </thead>
                        <tbody>
                            {evaluations.map((ev, i) => (
                                <tr key={i}>
                                    <td>{ev.date}</td>
                                    <td>
                                        <span className="tdb-c-perf-badge">{ev.performance}%</span>
                                    </td>
                                    <td>
                                        <span className="tdb-c-surperf-badge">{ev.surperformance}%</span>
                                    </td>
                                    <td>{ev.tolerance}</td>
                                    <td>
                                        <span className="tdb-c-statut-badge">{ev.statut}</span>
                                    </td>
                                    <td className="tdb-c-eval-name">{ev.evaluation}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </section>
        </div>
    );
}

/* ── Scoped styles ── */
const tdbCollabStyles = `
.tdb-collab-page {
    padding: 28px 32px;
    background: #f7f9fc;
    min-height: 100vh;
    font-family: 'Inter', ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, sans-serif;
    color: #111827;
}

/* ── Filters ── */
.tdb-c-filters {
    display: flex;
    align-items: flex-end;
    gap: 20px;
    padding: 22px 28px;
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 14px;
    box-shadow: 0 2px 12px rgba(32,67,133,.05);
    margin-bottom: 24px;
    flex-wrap: wrap;
}

.tdb-c-filter-group {
    display: flex;
    flex-direction: column;
    gap: 6px;
    flex: 1;
    min-width: 180px;
}

.tdb-c-filter-group:first-child {
    flex: 2;
}

.tdb-c-filter-date {
    flex: 1;
    max-width: 220px;
}

.tdb-c-filter-label {
    font-size: 12px;
    font-weight: 700;
    color: #2f4595;
    letter-spacing: .02em;
}

.tdb-c-select-wrap {
    position: relative;
}

.tdb-c-select {
    width: 100%;
    appearance: none;
    border: 1.5px solid #e5e7eb;
    border-radius: 10px;
    padding: 10px 36px 10px 14px;
    font-size: 13px;
    color: #374151;
    background: #fff;
    font-family: inherit;
    cursor: pointer;
    outline: none;
    transition: border-color .2s, box-shadow .2s;
}

.tdb-c-select:focus {
    border-color: #2f4595;
    box-shadow: 0 0 0 3px rgba(32,67,133,.1);
}

.tdb-c-select-icon {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #9ca3af;
    pointer-events: none;
}

.tdb-c-date-wrap {
    position: relative;
}

.tdb-c-date-input {
    width: 100%;
    border: 1.5px solid #e5e7eb;
    border-radius: 10px;
    padding: 10px 14px;
    font-size: 13px;
    color: #374151;
    background: #fff;
    font-family: inherit;
    outline: none;
    transition: border-color .2s, box-shadow .2s;
    box-sizing: border-box;
}

.tdb-c-date-input:focus {
    border-color: #2f4595;
    box-shadow: 0 0 0 3px rgba(32,67,133,.1);
}

.tdb-c-date-icon {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #9ca3af;
    pointer-events: none;
}

/* ── KPI cards grid ── */
.tdb-c-kpi-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 18px;
    margin-bottom: 28px;
}

.tdb-c-kpi-card {
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 14px;
    padding: 22px 24px;
    box-shadow: 0 2px 12px rgba(32,67,133,.05);
    display: flex;
    flex-direction: column;
    gap: 14px;
    transition: box-shadow .2s, transform .2s;
}

.tdb-c-kpi-card:hover {
    box-shadow: 0 6px 24px rgba(32,67,133,.1);
    transform: translateY(-2px);
}

.tdb-c-kpi-top {
    display: flex;
    align-items: center;
    gap: 14px;
}

.tdb-c-kpi-icon {
    width: 46px;
    height: 46px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.tdb-c-kpi-info {
    flex: 1;
}

.tdb-c-kpi-label {
    font-size: 13px;
    font-weight: 600;
    color: #6b7280;
}

.tdb-c-kpi-bottom {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.tdb-c-kpi-value {
    font-size: 32px;
    font-weight: 900;
    color: #2f4595;
    line-height: 1.1;
    letter-spacing: -.02em;
}

.tdb-c-kpi-hint {
    font-size: 12px;
    color: #9ca3af;
    font-weight: 500;
}

/* Red value for "non atteints" */
.tdb-c-kpi-card:nth-child(3) .tdb-c-kpi-value {
    color: #2f4595;
}

/* ── Evaluations section ── */
.tdb-c-evaluations {
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 14px;
    box-shadow: 0 2px 12px rgba(32,67,133,.05);
    overflow: hidden;
}

.tdb-c-eval-title {
    margin: 0;
    padding: 20px 28px 16px;
    font-size: 16px;
    font-weight: 800;
    color: #2f4595;
}

.tdb-c-table-wrap {
    overflow-x: auto;
}

.tdb-c-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
}

.tdb-c-table thead th {
    text-align: left;
    padding: 12px 20px;
    font-size: 11px;
    font-weight: 700;
    color: #2f4595;
    text-transform: uppercase;
    letter-spacing: .05em;
    background: #f1f5f9;
    border-bottom: 2px solid #e2e8f0;
    border-top: 1px solid #e2e8f0;
    white-space: nowrap;
}

.tdb-c-table tbody td {
    padding: 14px 20px;
    font-size: 13px;
    color: #374151;
    border-bottom: 1px solid #f1f5f9;
    vertical-align: middle;
}

.tdb-c-table tbody tr:hover td {
    background: #fafbfd;
}

.tdb-c-table tbody tr:last-child td {
    border-bottom: none;
}

.tdb-c-perf-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 42px;
    padding: 4px 12px;
    border-radius: 20px;
    background: #dcfce7;
    color: #15803d;
    font-size: 12px;
    font-weight: 700;
}

.tdb-c-surperf-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 42px;
    padding: 4px 12px;
    border-radius: 20px;
    background: #e8edf7;
    color: #2f4595;
    font-size: 12px;
    font-weight: 700;
}

.tdb-c-statut-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 4px 14px;
    border-radius: 20px;
    background: #fff1f2;
    color: #2f4595;
    font-size: 12px;
    font-weight: 700;
}

.tdb-c-eval-name {
    font-weight: 600;
    color: #2f4595;
}

/* ── Responsive ── */
@media (max-width: 1100px) {
    .tdb-c-kpi-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 768px) {
    .tdb-collab-page {
        padding: 16px;
    }

    .tdb-c-filters {
        flex-direction: column;
        align-items: stretch;
    }

    .tdb-c-filter-group:first-child,
    .tdb-c-filter-date {
        flex: 1;
        max-width: none;
    }

    .tdb-c-kpi-grid {
        grid-template-columns: 1fr;
    }
}
`;
